module.exports = __webpack_public_path__ + "img/inferCNV2.28e1e9b1.png";